import React from 'react';

import {
  Gallery /* already on v2 */,
  LoadingV2,
  useCartView,
  ModalV2,
  CartProductV2,
  AlertV2,
  ProductCustomisationModalV2,
  UpsellGalleryV2,
  AddonRemovedModalV2,
  CrossSellGalleryV2,
  OrderTotalSummaryV2,
  OutOfStockModal /* already on v2 */,
  PrimaryButton,
} from '@fingermarkglobal/cringer.components';

const CustomCartView = () => {
  const {
    formattedCart,
    upsellGroupedItems,
    isConcatUpsellProductsEnabled,
    menuState,
    loading,
    t,
    onEditProductHandler,
    onEmptyCartReturn,
    customisationProductSelected,
    openProductCustomisationModal,
    onCloseProductCustomisationModal,
    onConfirmCommitProduct,
    showPriceWarning,
    modalAccessibilityClass,
    openGroupedProductModal,
    groupedProductSelected,
    onCloseGroupedProductModal,
    openComboProductModal,
    onCloseComboProductModal,
    comboProductSelected,
    formattedUpsells,
    formatPrice,
    showEnergyInformation,
    isCustomisationHeaderEnabled,
    isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled,
    showQuantityControllerLabel,
    showAddonAvailability,
    openCondAddonModal,
    onCloseAddonRemovedModal,
    hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero,
    hideNoPrefixWhenDefaultNotSelected,
    crossSellEnabled,
    showCrossSellCategoryTitle,
    formattedCrossSells,
    cartOrderSummary,
    showOrderTotalSummary,
    hideComboProductsUnitPrice,
    isCouponQuantityDisabled,
    alignButtons,
    isDeliverectProvider,
    openOutOfStockModal,
    showOutOfStockModal,
    onCloseOutOfStockModal,
    staged,
    setStaged,
    upsellEnabled,
  } = useCartView({ showCategoriesHeader: true });

  return (
    <div className="cart-view">
      <ModalV2
        open={openProductCustomisationModal}
        formatPrice={formatPrice}
        contentContainerClassName={
          isDeliverectProvider ? 'modal__container--content_deliverect' : undefined
        }
        modalClassName={isDeliverectProvider ? 'modal_deliverect' : undefined}
      >
        <ProductCustomisationModalV2
          product={customisationProductSelected}
          onCloseCallback={onCloseProductCustomisationModal}
          onConfirmCallback={onConfirmCommitProduct}
          showOutOfStockModal={showOutOfStockModal}
          setStaged={setStaged}
          showPriceWarning={showPriceWarning}
          formatPrice={formatPrice}
          isCustomisationHeaderEnabled={isCustomisationHeaderEnabled}
          isCategoryTotalizerEnabled={isCategoryTotalizerEnabled}
          isAdditionalMessageEnabled={isAdditionalMessageEnabled}
          showQuantityControllerLabel={showQuantityControllerLabel}
          showAddonAvailability={showAddonAvailability}
          hidePriceWhenQuantityLessOrEqualDefault={hidePriceWhenQuantityLessOrEqualDefault}
          hidePriceWhenZero={hidePriceWhenZero}
          isCouponQuantityDisabled={isCouponQuantityDisabled}
          titleSeparator=" | "
        />
      </ModalV2>
      <ModalV2
        data-test="grouped-option-modal"
        className={modalAccessibilityClass}
        open={openGroupedProductModal}
        title={groupedProductSelected?.title}
        closeModal={onCloseGroupedProductModal}
        closeText={t('cartGroupedModalSecondaryAction')}
        formatPrice={formatPrice}
      >
        <Gallery
          items={groupedProductSelected?.grouped}
          dynamicColumns={true}
          formatPrice={formatPrice}
          showAddonAvailability={showAddonAvailability}
          t={t}
        />
      </ModalV2>
      <ModalV2
        data-test="combo-option-modal"
        className={modalAccessibilityClass}
        open={openComboProductModal}
        title={t('cartComboModalTitle')}
        closeModal={onCloseComboProductModal}
        closeText={t('cartComboModalSecondaryAction')}
        formatPrice={formatPrice}
      >
        <Gallery
          items={comboProductSelected?.options}
          dynamicColumns={true}
          formatPrice={formatPrice}
          showAddonAvailability={showAddonAvailability}
          t={t}
        />
      </ModalV2>
      <ModalV2 open={openCondAddonModal}>
        <AddonRemovedModalV2 onCloseCallback={onCloseAddonRemovedModal} />
      </ModalV2>
      <ModalV2
        open={openOutOfStockModal}
        contentContainerClassName="modal__container-content_out-of-stock border-orange"
      >
        <OutOfStockModal
          product={customisationProductSelected}
          staged={staged}
          onCloseCallback={onCloseOutOfStockModal}
          onConfirmCallback={onConfirmCommitProduct}
          onCloseProductCustomisationModal={onCloseProductCustomisationModal}
        />
      </ModalV2>
      {loading && (
        <div className="cart-view--loading">
          <LoadingV2 />
        </div>
      )}
      {menuState?.matches('failure') && (
        <div className="cart-view--failure">
          <AlertV2 type="danger" message={menuState.context.message} />
        </div>
      )}
      {menuState?.matches('success') && (
        <div data-test="cart-page-success" className="cart-view--success">
          {formattedCart.length === 0 && (
            <div className="cart-view--success--empty-cart">
              <AlertV2 message={t('cartEmptyMessage')} />
              <PrimaryButton onClick={onEmptyCartReturn}>
                {t('cartEmptyPrimaryAction')}
              </PrimaryButton>
            </div>
          )}
          <div className="cart-view--success--products">
            {formattedCart.map((product, i) => (
              <CartProductV2
                key={`cart-product-${i}`}
                product={product}
                t={t}
                onEditProductHandler={onEditProductHandler}
                changeText={t('cartChangeAction')}
                removeText={t('cartRemoveAction')}
                formatPrice={formatPrice}
                showEnergyInformation={showEnergyInformation}
                showAddonAvailability={showAddonAvailability}
                disableModifyUpsellOnCart={true}
                isCouponQuantityDisabled={isCouponQuantityDisabled}
                hideDisabledButtons={hideDisabledButtons}
                RewardPointsComponent={null}
                hideNoPrefixWhenDefaultNotSelected={hideNoPrefixWhenDefaultNotSelected}
                hideComboProductsUnitPrice={hideComboProductsUnitPrice}
                alignButtons={alignButtons}
              />
            ))}
            {showOrderTotalSummary && (
              <OrderTotalSummaryV2
                t={t}
                orderTotalSummary={cartOrderSummary}
                products={formattedCart}
                RewardPointsComponent={null}
              />
            )}
          </div>
          {upsellEnabled && formattedCart.length > 0 && (
            <UpsellGalleryV2
              upsellGroupedItems={upsellGroupedItems}
              isConcatUpsellProductsEnabled={isConcatUpsellProductsEnabled}
              title={t('upsellModalTitle')}
              items={formattedUpsells}
              emptyAction={onEmptyCartReturn}
              emptyActionText={t('cartUpsellAction')}
              emptyMessage={t('cartUpsellTitle')}
              galleryCardButtonActionText={t('cartUpsellGalleryCardButtonActionText')}
              formatPrice={formatPrice}
              showAddonAvailability={showAddonAvailability}
              t={t}
            />
          )}
          {crossSellEnabled && formattedCart.length > 0 && (
            <CrossSellGalleryV2
              items={formattedCrossSells}
              galleryCardButtonActionText={t('cartUpsellGalleryCardButtonActionText')}
              formatPrice={formatPrice}
              showAddonAvailability={showAddonAvailability}
              showCrossSellCategoryTitle={showCrossSellCategoryTitle}
              t={t}
            />
          )}
        </div>
      )}
    </div>
  );
};

export { CustomCartView };
